// src/components/accueil/personnaliser/BarrePersonnaliser.tsx — SCE Issues
// Le bouton « Personnaliser » de l'accueil et la barre du mode (lot 3 du chantier
// du 03/11, docs/chantier-accueil.md) : on range, puis « Terminé » enregistre,
// « Annuler » laisse tout comme avant. « Revenir au modèle » remet le modèle du
// rôle dans le brouillon (Annuler le rattrape encore).

import type { JSX } from 'react'
import { LayoutDashboard } from 'lucide-react'
import { Button } from '@/components/ui/Button'

export function BoutonPersonnaliser({ onClick }: { onClick: () => void }): JSX.Element {
  return (
    <Button variant="secondary" size="lg" iconLeft={<LayoutDashboard size={18} aria-hidden="true" />} onClick={onClick}>
      Personnaliser
    </Button>
  )
}

export function BarrePersonnaliser({
  auModele,
  onModele,
  onAnnuler,
  onTerminer,
}: {
  /** Le brouillon est déjà le modèle : « Revenir au modèle » n'a rien à faire. */
  auModele: boolean
  onModele: () => void
  onAnnuler: () => void
  onTerminer: () => void
}): JSX.Element {
  return (
    <div className="perso-barre" role="region" aria-label="Personnaliser l’accueil">
      <LayoutDashboard size={20} aria-hidden="true" style={{ flexShrink: 0 }} />
      <div className="flex flex-col" style={{ flex: 1, minWidth: 0 }}>
        <strong style={{ fontSize: 15, fontWeight: 500 }}>Personnaliser l’accueil</strong>
        <span style={{ fontSize: 13, opacity: 0.8 }}>
          Glissez une carte par sa poignée, ou rangez-la avec ⋯. Ajoutez-en depuis le bas des colonnes.
        </span>
      </div>
      <button type="button" className="perso-lien" onClick={onModele} disabled={auModele}>
        Revenir au modèle
      </button>
      <button type="button" className="perso-annuler" onClick={onAnnuler}>
        Annuler
      </button>
      <Button variant="primary" onClick={onTerminer}>
        Terminé
      </Button>
    </div>
  )
}
